import api from "./api"


export function fnGetAllFields(cParams) {
    const response = api.get(`/op-panel/fields${cParams ? `?${cParams}` : ""}`);
    return response;
}

export function fnCreateActivityField(oFieldData) {
    const response = api.post(`/op-panel/fields`, oFieldData);
    return response;
}

export function fnUpdateField(oFieldData) {
    const response = api.patch(`/op-panel/fields/${oFieldData?.opfd_nid}`, oFieldData);
    return response;
}


export function fnUpdateFieldRow(nActivityId, oData) {
    const response = api.put(`/operational-panel-activity-fields/${nActivityId}`, oData)
    return response
}